<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <!-- <a-col :md="8" :sm="24">
              <a-form-item label="Top-up Amount" prop="topUpAmount">
                <a-input v-model="queryParam.topUpAmount" placeholder="Please enter top-up amount" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="Bonus Amount" prop="giveMoney">
                <a-input v-model="queryParam.giveMoney" placeholder="Please enter bonus amount" allow-clear/>
              </a-form-item>
            </a-col> -->
            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="Tag Name" prop="tagTitle">
                  <a-input v-model="queryParam.tagTitle" placeholder="Please enter tag name" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="Product ID" prop="productId">
                  <a-input v-model="queryParam.productId" placeholder="Please enter product ID" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="8" :sm="24">
                <a-form-item label="Sort (Ascending)" prop="sort">
                  <a-input v-model="queryParam.sort" placeholder="Please enter sort order" allow-clear/>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-operations">
       <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['golf:recharge/menu:add']">
          <a-icon type="plus" />Add
        </a-button>
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>
        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical"  />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" >
            <a-icon type="edit" />Edit
          </a>
          <a-divider type="vertical"  />
          <a @click="handleDelete(record)" >
            <a-icon type="delete" />Delete
          </a>
        </span>
      </a-table>
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => `Total ${total} items`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageRechargeMenu, delRechargeMenu } from '@/api/golf/rechargeMenu'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'RechargeMenu',
  components: {
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      advanced: false,
      single: true,
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      queryParam: {
        topUpAmount: null,
        giveMoney: null,
        tagTitle: null,
        productId: null,
        sort: null,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        {
          title: 'Top-up Amount',
          dataIndex: 'topUpAmount',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Bonus Amount',
          dataIndex: 'giveMoney',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Tag Name',
          dataIndex: 'tagTitle',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Sort (Ascending)',
          dataIndex: 'sort',
          ellipsis: true,
          align: 'center'
        },
        {
          title: 'Actions',
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
  },
  watch: {
  },
  methods: {
    getList () {
      this.loading = true
      pageRechargeMenu(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    resetQuery () {
      this.queryParam = {
        topUpAmount: undefined,
        giveMoney: undefined,
        tagTitle: undefined,
        productId: undefined,
        sort: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: 'Confirm deletion of selected data?',
        content: 'Selected IDs: ' + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delRechargeMenu(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                'Deleted successfully',
                3
              )
          })
        },
        onCancel () {
          that.ids = []
        }
      })
    },
    handleExport () {
      var that = this
      this.$confirm({
        title: 'Confirm export?',
        content: 'This will export all data under current filters, not just selected rows.',
        onOk () {
          that.download('golf/golf-recharge-menu/export', {
            ...that.queryParam
          }, `recharge_menu_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
